import React, { useState } from 'react';

const ConfirmDeleteModal = ({ isOpen, onClose, onConfirm, title, message, itemName }) => {
    const [reason, setReason] = useState('');

    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        onConfirm(reason);
        setReason(''); // Reset reason after confirm
    };

    return (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header bg-danger text-white">
                        <h5 className="modal-title">
                            <i className="fas fa-exclamation-triangle me-2"></i>
                            {title || 'ยืนยันการลบ'}
                        </h5>
                        <button
                            type="button"
                            className="btn-close btn-close-white"
                            onClick={onClose}
                        ></button>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="modal-body">
                            <p>{message || 'คุณต้องการลบรายการนี้ใช่หรือไม่?'}</p>
                            {itemName && <p className="fw-bold text-center">{itemName}</p>}

                            <div className="mb-3">
                                <label htmlFor="deleteReason" className="form-label">ระบุเหตุผลในการลบ (Force Delete): <span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="deleteReason"
                                    value={reason}
                                    onChange={(e) => setReason(e.target.value)}
                                    placeholder="เช่น ลูกค้ายกเลิก, ข้อมูลผิดพลาด"
                                    required
                                    autoFocus
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={onClose}
                            >
                                ยกเลิก
                            </button>
                            <button
                                type="submit"
                                className="btn btn-danger"
                                disabled={!reason.trim()}
                            >
                                ยืนยันการลบ
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDeleteModal;
